import { debounce } from 'debounce'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      page: this.page || 1,
      per_page: this.per_page || 10,
      region_guid: '',
      keyword: '',
      filter: {
        'day_cm1.from': moment().format('YYYY-MM-01'),
        'day_cm1.till': moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      },
      date: {
        from: moment().format('YYYY-MM-01'),
        to: moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      },
      isFilterEnabled: false
    }
  },
  computed: {
    ...mapGetters('profile', ['getUserSourcesPermission']),
    ...mapGetters('authentication', ['getUserGuid']),
    isPending () {
      return this.isFindPending && this.list.length === 0
    }
  },
  methods: {
    onPageChange (pagination) {
      this.page = pagination.page + 1
      this.per_page = pagination.per_page
      this.pushState()
      this._fetch()
      // window.scrollTo(0, 0)
    },
    onFilter (event) {
      this.page = 1

      Object.assign(
        this.filter,
        ...Object.keys(event)
          .filter(key => {
            if (key === 'humanreadble' && !event[key]) {
              this.filter[key] = ''
            }
            return (event[key] !== undefined || event[key] !== null) && key
          })
          .map(key => {
            return {
              [key]: event[key]
            }
          })
      )

      this._initHumanreadble()
      this._fetch()
    },
    onSearch: debounce(function () {
      this.page = 1
      this.pushState()
      this._fetch()
    }, 1000),
    onDateFilter () {
      this.page = 1
      Object.assign(this.filter, {
        'day_cm1.from': this.date.from,
        'day_cm1.till': this.date.to
      })
      this._updateDateRefs()
      this.pushState()
      this._fetch()
    },
    pushState () {
      this.$router.push(
        {
          query: {
            page: this.page.toString(),
            per_page: this.per_page.toString(),
            keyword: this.keyword,
            ...this.filter
          }
        },
        () => {},
        () => {}
      )
    },
    disableFilters () {
      this.$refs.filter.clearAll()
    },
    _initFilters (filters) {
      this.page = (this.$route.query && this.$route.query.page) || this.page
      this.per_page =
        (this.$route.query && this.$route.query.per_page) || this.per_page
      Object.assign(this.filter, filters)

      if (this.filter['day_cm1.from'] && this.filter['day_cm1.till']) {
        this.date = {
          from: this.filter['day_cm1.from'],
          to: this.filter['day_cm1.till']
        }
      }
    },
    _initHumanreadble () {
      if (this.filter['humanreadble']) {
        // Object.assign(this.filter, {
        //   'day_cm1.from': moment().format('YYYY-01-01'),
        //   'day_cm1.till': moment().format('YYYY-12-31')
        // })
        // this.date = {
        //   from: this.filter['day_cm1.from'],
        //   to: this.filter['day_cm1.till']
        // }
      }

      this._updateDateRefs()
    },
    _updateDateRefs () {
      if (
        this.$refs.filter &&
        this.$refs.filter.$refs &&
        this.$refs.filter.$refs['day_cm1.from']
      ) {
        this.$refs.filter.$refs['day_cm1.from'].setDateValue(
          new Date(this.date.from)
        )
        this.$refs.filter.$refs['day_cm1.till'].setDateValue(
          new Date(this.date.to)
        )
      }
    }
  },
  beforeMount () {
    this._initFilters(this.$route.query)
    this._initHumanreadble()
  },
  mounted () {
    this.onFilter(this.filter)
    this._updateDateRefs()
  }
}
